import React from 'react';
import { toast } from 'react-hot-toast';
import api from '../../common/api';
import { copy } from '../../common/utils';
import Modal from '../../common/modal';
import Withdraw from './Withdraw';

const Recom = ({ userInfo, getUserInfo }) => {
    const exAff = async () => {
        try {
            const response = await api("post", "/api/user/exaff", null);
            if (response.message === "401") {
                localStorage.clear();
                window.location.href = '/login';
            } else {
                if (response.status) {
                    getUserInfo();
                    toast.success("已兑换为余额");
                } else {
                    toast.error(response.message);
                }
            }
        } catch (error) {
            toast.error("网络错误，请重试");
        }
    };

    const inviteLink = `${process.env.REACT_APP_LINK}/?r=${userInfo.id}`;

    return (
        <Modal target="recom" title="邀请好友">
            <div className="space-y-4">
                {/* 邀请链接卡片 */}
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-4">
                    <div className="flex items-center space-x-3 mb-3">
                        <div className="p-2 bg-blue-100 rounded-lg">
                            <svg className="h-5 w-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                            </svg>
                        </div>
                        <h2 className="text-base font-semibold text-gray-900">您的邀请链接</h2>
                    </div>
                    <div className="bg-white rounded-lg p-3 mb-3">
                        <p className="text-sm text-gray-600 break-all">{inviteLink}</p>
                    </div>
                    <button
                        onClick={() => copy(inviteLink)}
                        className="w-full flex items-center justify-center space-x-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-3 py-1.5 rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-300"
                    >
                        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                        </svg>
                        <span>复制链接</span>
                    </button>
                </div>

                {/* 邀请规则卡片 */}
                <div className="bg-white rounded-xl p-4 shadow-sm">
                    <div className="flex items-center space-x-3 mb-3">
                        <div className="p-2 bg-green-100 rounded-lg">
                            <svg className="h-5 w-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                            </svg>
                        </div>
                        <h2 className="text-base font-semibold text-gray-900">邀请规则</h2>
                    </div>
                    <ul className="space-y-2">
                        {process.env.NOFREE === 'true' && (
                            <li className="flex items-start space-x-2">
                                <svg className="h-4 w-4 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                                <span className="text-sm text-gray-600">被邀请者注册可获得 1GB 不限时流量</span>
                            </li>
                        )}
                        <li className="flex items-start space-x-2">
                            <svg className="h-4 w-4 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            </svg>
                            <span className="text-sm text-gray-600">您可获得被邀请者每次充值金额的 <span className="text-blue-600 font-medium">{userInfo.aff_rate}%</span> 作为奖励</span>
                        </li>
                        <li className="flex items-start space-x-2">
                            <svg className="h-4 w-4 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            </svg>
                            <span className="text-sm text-gray-600">奖励金额满 100 可联系客服进行 USDT 或支付宝提现</span>
                        </li>
                    </ul>
                </div>

                {/* 邀请总结卡片 */}
                <div className="bg-white rounded-xl p-4 shadow-sm">
                    <div className="flex items-center space-x-3 mb-3">
                        <div className="p-2 bg-purple-100 rounded-lg">
                            <svg className="h-5 w-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                            </svg>
                        </div>
                        <h2 className="text-base font-semibold text-gray-900">邀请总结</h2>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        <div className="bg-gray-50 rounded-lg p-3">
                            <p className="text-xs text-gray-500 mb-1">当前获得奖励</p>
                            <p className="text-xl font-bold text-blue-600">{userInfo.aff}￥</p>
                        </div>
                        <div className="bg-gray-50 rounded-lg p-3">
                            <p className="text-xs text-gray-500 mb-1">当前邀请人数</p>
                            <p className="text-xl font-bold text-purple-600">{userInfo.aff_count}</p>
                        </div>
                    </div>
                    <div className="space-y-2 mt-3">
                        <button
                            onClick={exAff}
                            className="w-full flex items-center justify-center space-x-2 bg-gradient-to-r from-purple-500 to-indigo-600 text-white px-3 py-1.5 rounded-lg hover:from-purple-600 hover:to-indigo-700 transition-all duration-300"
                        >
                            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>兑换为余额</span>
                        </button>
                        <Withdraw userInfo={userInfo} />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Recom;